import { ModelEntityReference } from '@upright/common/model/input/types';
import { fetchModelEntityDataInBulkOrThrow } from '@upright/ui/api/model/output/scores/model-entity-data';
import { useQuery } from '@tanstack/react-query';

type FetchMixinComparisonDataParams = Parameters<typeof fetchModelEntityDataInBulkOrThrow>[0];

function generateFetchMixinComparisonDataQueryKey(params?: FetchMixinComparisonDataParams) {
  return ['fetch-mixin-comparison-data', ...(params ? [params] : [])];
}

export function useFetchMixinComparisonDataQuery(entities: ModelEntityReference[]) {
  const params = {
    payload: { entities, version: 'master' },
  };

  return useQuery({
    queryKey: generateFetchMixinComparisonDataQueryKey(params),
    queryFn: async () => {
      if (entities.length > 0) {
        return await fetchModelEntityDataInBulkOrThrow(params);
      }
      return [];
    },
    refetchOnWindowFocus: false,
    notifyOnChangeProps: ['data', 'error'],
    staleTime: 10 * 1000,
    gcTime: Infinity,
  });
}
